export default __webpack_public_path__ + "media/images/placeholder/kwestgraduation-11cec77beff6e976a1ec9b32ceb6edae.png";